var adContext = require('src/interlock/product/ads/ad-context/ad-context');
var adFinder = require('src/interlock/product/ads/ad-manager/ad-finder');
var REFRESH_ZONES = require('src/interlock/product/ads/refresh-zones.js');

function _getAdUnitsGroupByCorrelator(adUnits) {
    var units = adUnits.sort(function(adUnit1, adUnit2) {
        return adUnit1.getCorrelator() - adUnit2.getCorrelator();
    });
    var byCorrelator = {};
    units.forEach(function(adUnit) {
        if (!byCorrelator[adUnit.getCorrelator()]) {  byCorrelator[adUnit.getCorrelator()] = [];  }
        byCorrelator[adUnit.getCorrelator()].push(adUnit);
    });
    return byCorrelator;
}

/**
 * Refreshes all ad units matching the given zone
 * @param  {Object} adIdToSlot
 * @param  {Array} adUnits ad units
 * @param  {String} zone refresh zone
 * @param  {Object} data event data
 * @return {void}
 */
function _refreshAdUnitsByZone(adIdToSlot, adUnits, zone, data) {
    var groupByCorrelators = _getAdUnitsGroupByCorrelator(adUnits);
    for (var correlator in groupByCorrelators) {
        var units = groupByCorrelators[correlator];
        var slots = adFinder.findAdUnits(zone, units).map(function (adUnit) {
            return adIdToSlot[adUnit.getId()];
        });
        _refreshGoogleWait(slots, data);
    }
}
/**
 * Refreshes current unit
 * @param  {Object} object with properties: required 'googleSlot', optional 'customTargetingValues'
 * @param  {Object} data event data
 * @return {void}
 */
function _refreshAdSlot (slot, data) {
    _refreshGoogleWait([slot], data);
}

/**
 * Refreshes all ad units
 * @param  {Object} adIdToSlot
 * @param  {Array} adUnits ad units
 * @param  {Object} data event data
 * @return {void}
 */
function _refreshAllAdUnits(adUnits, adIdToSlot, data) {
    var groupByCorrelators = _getAdUnitsGroupByCorrelator(adUnits);
    for (var correlator in groupByCorrelators) {
        var units = groupByCorrelators[correlator];

        var slots = units.map(function (adUnit) {
            return adIdToSlot[adUnit.getId()];
        });
        _refreshGoogleWait(slots, data);
    }
}

function _refreshGoogleWait(slots, data){
    if (window.googletag.pubads){
        if (slots.length) {
            if(data && data.ts && window.googletag.pubads().setTargeting) {
                window.googletag.pubads().setTargeting('ts',data.ts);
            }
            //window.googletag.pubads().clear(slots);

            var googleSlots = [];
            slots.forEach(function(slot){
                for(var key in slot.customTargetingValues) {
                    window.googletag.pubads().setTargeting(key, slot.customTargetingValues[key]);
                }
                if(slot.moduleValue) {
                    window.googletag.pubads().setTargeting('module', slot.moduleValue);
                }
                googleSlots.push(slot.googleSlot);
            });
            window.googletag.pubads().refresh(googleSlots);
        }
    }
    else {
        setTimeout(function(){
            _refreshGoogleWait(slots, data);
        },500);
    }
}
/**
 * Retarget ad units.  this is more expensive than refreshing so only call with
 * sitename or other top level targeting values change.  This will effect view ability and other
 * core metrics.
 *
 * @param  {Object} adIdToSlot
 * @param  {Array} adUnits ad units
 * @param  {String} zone refresh zone
 * @param  {Function} renderAds render ad function
 * @return {void}
 */
function _retargetAdUnitsByZone(adIdToSlot, adUnits, zone, renderAds) {
    //var adUnits = adFinder.findAdUnits(zone);
    // clear ad content
    var slots = adFinder.findSlots(zone, adIdToSlot, adUnits);
    _retargetGoogleWait(slots, renderAds, adUnits);
}

/**
 * Retarget all ad units.  this is more expensive than refreshing so only call with
 * sitename or other top level targeting values change.  This will effect view ability and other
 * core metrics.
 *
 * @param  {Object} adIdToSlot
 * @param  {Array} adUnits ad units
 * @param  {Function} renderAds render ad function
 * @return {void}
 */
function _retargetAllAdUnits(adUnits, adIdToSlot, renderAds, specialCaseIds) {
    // clear ad content
    var slots = adUnits.map(function (adUnit) {
        return adIdToSlot[adUnit.getId()];
    });
    if(specialCaseIds && specialCaseIds.length > 0) {
        adUnits = adUnits.filter(function (adUnit) {
            return specialCaseIds.indexOf(adUnit.getId()) < 0 || adUnit.getRefreshZones().indexOf(REFRESH_ZONES.VIEWPORT) < 0;
        });
    }
    _retargetGoogleWait(slots, renderAds, adUnits);
}

function _retargetGoogleWait(slots, renderAds, adUnits){
    if (window.googletag.pubads){
        if (slots.length) {
            if(window.googletag.pubads().clear){
                window.googletag.pubads().clear(slots);

            }
            // notify ad unit of retarget
            adContext.markAsNewPage();
            adUnits.forEach(function (adUnit) {
                $('#' + adUnit.getId()).remove();
                adUnit.retarget();
            });
            if(renderAds){  // render ads
                renderAds();
            }
        }
    }
    else {
        setTimeout(function(){
            _retargetGoogleWait(slots);
        },500);
    }
}

module.exports = {
    refreshAdSlot: _refreshAdSlot,
    refreshAdUnitsByZone : _refreshAdUnitsByZone,
    refreshAllAdUnits:_refreshAllAdUnits,
    retargetAdUnitsByZone : _retargetAdUnitsByZone,
    retargetAllAdUnits:_retargetAllAdUnits,
    getAdUnitsGroupByCorrelator: _getAdUnitsGroupByCorrelator
};




//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-manager/ad-retarget-refresh-manager.js
// module id = 175
// module chunks = 36